import type { FC, PropsWithChildren, ReactNode } from 'react';

import OnboardingLogoutButton from '@/components/ui/OnboardingLogoutButton/OnboardingLogoutButton.tsx';

type DnaStepLayoutProps = PropsWithChildren<{
  eyebrow: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  maxWidthClassName?: string;
}>;

const DnaStepLayout: FC<DnaStepLayoutProps> = ({
  eyebrow,
  title,
  description,
  maxWidthClassName = 'max-w-[760px]',
  children,
}) => {
  return (
    <div className="fixed inset-0 overflow-y-auto bg-[var(--ink)] text-[var(--cream)]">
      <OnboardingLogoutButton />

      <div className="flex min-h-full w-full items-center justify-center px-5 py-10 sm:py-12">
        <main
          className={`flex w-full ${maxWidthClassName} flex-col items-center text-center`}
        >
          <p className="font-sans text-[11px] font-normal uppercase tracking-[0.24em] text-[var(--gold)]">
            {eyebrow}
          </p>

          <h1 className="mt-2 font-feature text-[clamp(30px,4vw,38px)] font-semibold leading-[1.2] tracking-[-0.02em] text-[var(--cream)]">
            {title}
          </h1>

          {description ? (
            <p className="mt-2 whitespace-pre-line font-sans text-base italic leading-[1.45] text-[var(--cream-3)]">
              {description}
            </p>
          ) : null}

          {children}
        </main>
      </div>
    </div>
  );
};

export default DnaStepLayout;
